import { filter, get, find, includes, intersectionWith, isEqual } from 'lodash';
import { toUniqueTrims } from '../utils';

export const getTrimsWithSelectedFeatures = (
  trims,
  selections,
  keyFeatures
) => {
  // get common codes across all selected key features.
  const compatibleTrims = selections.selectedKeyFeatures.reduce(
    (accum, code) => {
      const keyFeature = find(keyFeatures, { code });
      if (keyFeature) {
        if (accum.length > 0) {
          return intersectionWith(accum, keyFeature.styleIds, isEqual);
        }
        return keyFeature.styleIds;
      }
      return accum;
    },
    []
  );

  // return trims where options exist with compatible style Ids.
  return trims
    .map((trim) => {
      return {
        ...trim,
        options: trim.options.filter((option) => {
          return compatibleTrims.includes(option.styleId);
        }),
      };
    })
    .filter((t) => t.options.length > 0);
};

export const getTrimsWithSelectedEngine = (trims, selections) => {
  if (!selections) {
    return trims;
  }
  return trims
    .map((trim) => {
      return {
        ...trim,
        options: trim.options.filter((option) =>
          selections.engine && selections.engine !== 'NA'
            ? option.engineCode === selections.engine
            : true
        ),
      };
    })
    .filter((t) => t.options.length > 0);
};

export const getTrimGroupWDTSelection = (
  trimsWithSelectedBodyType,
  selections
) => {
  const trimsMatchDriveType = trimsWithSelectedBodyType.filter((trim) => {
    const driveType = get(trim, 'driveType.id');
    const rearWheelType = get(trim, 'rearWheelType');

    return (
      driveType === selections.driveType &&
      rearWheelType === selections.rearWheelType
    );
  });

  const trimsNotMatchDriveType = trimsWithSelectedBodyType.filter((trim) => {
    const driveType = get(trim, 'driveType.id');
    const rearWheelType = get(trim, 'rearWheelType');
    return (
      driveType !== selections.driveType ||
      rearWheelType !== selections.rearWheelType
    );
  });

  const trimNamesInSelectedDriveType = toUniqueTrims(trimsMatchDriveType);
  const trimsOnlyInUnselectedDriveType = trimsNotMatchDriveType.filter(
    (trim) => !includes(trimNamesInSelectedDriveType, trim.trimName)
  );

  const filteredTrims = [
    ...trimsOnlyInUnselectedDriveType,
    ...trimsMatchDriveType,
  ];

  const displayTrims = filter(trimsWithSelectedBodyType, (trim) => {
    const filterTrim = find(filteredTrims, { styleId: trim.styleId });
    if (filterTrim) return filterTrim;
  });

  const displayCompare = displayTrims.length > 1;

  return displayTrims.map((trim) => {
    return {
      ...trim,
      compareAll: displayCompare,
      displayOnlyLabel: trim.driveType.id !== selections.driveType,
    };
  });
};
